module.exports = __webpack_public_path__ + "static/media/repuestos2.dd7f91c7.png";